export default __webpack_public_path__ + "static/media/tag.e63063fa.svg";